const guard = {
  beneficiary: ['Claim_Admin', 'Claim_User_Review'],
  'beneficiary-export': ['Claim_Admin'],
  'beneficiary-import': ['Claim_Admin'],
  'beneficiary-update': ['Claim_Admin'],
  'beneficiary-reissue': ['Claim_Admin'],
  'request-activation': ['Claim_Admin'],
  'request-denial': ['Claim_Admin'],
  issues: ['Claim_Admin', 'Claim_Issue_Review'],
};

export const navigationGuard = Object.freeze(guard);
